module.exports = __webpack_public_path__ + "static/media/HomeFail.da78c67e.png";